import React, { useEffect, useState } from 'react'
import { useEditReportTeamData, useReportApprovers, useReportTeamInsert, useReportType, useReportWritersAndReviewer, useUpdateReportTeam } from '../../../common/CommonQueries'
import { useHistory, useParams } from 'react-router-dom';
import { Button, Checkbox, Container, FormControlLabel, Grid, LinearProgress, MenuItem, TextField, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import { useFetchContext } from '../../../common/FetchContext';
import { Autocomplete } from '@material-ui/lab';

export const EditReportTeam = () => {

    const { reportTeamId } = useParams() as { reportTeamId: string };
    const { authAxios } = useFetchContext();

    const history = useHistory();

    const [repoertType, setRepoertType] = useState('');
    const [repoertWritter, setRepoertWritter] = useState('');
    const [repoertApprover, setRepoertApprover] = useState('');
    const [repoertReviwer, setRepoertReviwer] = useState('');
    const [showApprover, setShowApprover] = useState(false);
    const [isReviewerPM, setIsReviewerPM] = useState(false);
    const [ntpDays, setNtpDays] = useState('');
    const [errors, setErrors] = useState<{
        repoertType?: string;
        repoertWritter?: string;
        repoertApprover?: string;
        repoertReviwer?: string;
        ntpDays?: string;
    }>({});




    const handleCheckboxChange = (event: any) => {
        const checked = event.target.checked;
        setShowApprover(checked);
        if (checked) {
            setRepoertApprover('');
        }
    };
    const {
        error: errorReportWriter,
        data: ReportWriterData = [],
        isLoading: isLoadingReportWirter,
        isError: isErrorReportWriter,
    } = useReportWritersAndReviewer();

    const {
        error: errorReportApprover,
        data: ReportApproverData = [],
        isLoading: isLoadingReportApprover,
        isError: isErrorReportApprover,
    } = useReportApprovers();
    const {
        error: errorReportType,
        data: ReportType,
        isLoading: isLoadingReportType,
        isError: isErrorReportType,
    } = useReportType();

    const {
        data: EditReportTeamData,
        error: errorEditReportTeamData,
        isLoading: isLoadingEditReportTeamData,
        isError: isErrorEditReportTeamData
    } = useEditReportTeamData(reportTeamId)

    const { mutateAsync: mutate } = useUpdateReportTeam();

    useEffect(() => {
        if (EditReportTeamData) {
            setRepoertType(EditReportTeamData.report_name?.toString() || '');
            setRepoertWritter(EditReportTeamData.writer?.toString() || '');
            setRepoertApprover(EditReportTeamData.approver?.toString() || '');
            setRepoertReviwer(EditReportTeamData.reviewer?.toString() || '');
            setShowApprover(EditReportTeamData.is_projmanager || false);
            setIsReviewerPM(EditReportTeamData.reviewer_pm || false);
            setNtpDays(EditReportTeamData.duration?.toString() || '');
        }
    }, [EditReportTeamData]);



    if (isLoadingReportType || isLoadingReportWirter || isLoadingReportApprover || isLoadingEditReportTeamData) {
        return (
            <>
                <LinearProgress />
                <Typography variant="body1" style={{ marginTop: "16px" }}>
                    Loading Report Team Data...
                </Typography>
            </>
        );
    }



    const validate = () => {
        const newErrors: typeof errors = {};

        if (!repoertType) newErrors.repoertType = "Report Type is required";
        if (!repoertWritter) newErrors.repoertWritter = "Writer is required";

        if (isReviewerPM === false && repoertReviwer === "") {
            newErrors.repoertReviwer = "Reviewer is required unless Project Manager is checked"
        }

        if (showApprover === false && repoertApprover === "") {
            newErrors.repoertApprover = "Approver is required unless Project Manager is checked";
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleReviewerPMChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        const checked = event.target.checked;
        setIsReviewerPM(checked);
        if (checked) {
            setRepoertReviwer('');
        }
    };





    const handleReportType = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRepoertType(event.target.value);
    };

    // const handleReportApprover = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setRepoertApprover(event.target.value);
    // };

    // const handleReportWritter = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setRepoertWritter(event.target.value);
    // };

    // const handleReportReviwer = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setRepoertReviwer(event.target.value);
    // };
    const handleReportApprover = (value: any) => {
        setRepoertApprover(value);
    };

    const handleReportWritter = (value: any) => {
        setRepoertWritter(value);
    };

    const handleReportReviwer = (value: any) => {
        setRepoertReviwer(value);
    };

    const handleSubmit = async () => {
        if (!validate()) return;



        try {
            await mutate({
                authAxios,
                id: EditReportTeamData.id,
                report_type: EditReportTeamData.report_type,
                writer: repoertWritter,
                approver: showApprover ? '' : repoertApprover,
                reviewer: isReviewerPM ? "" : repoertReviwer,
                duration: ntpDays,
                is_projmanager: showApprover,
                reviewer_pm: isReviewerPM
            });
            toast.success("Report Team Updated Successfully");
            setRepoertType('');
            setRepoertWritter('');
            setRepoertApprover('');
            setRepoertReviwer('');
            setShowApprover(false);
            setIsReviewerPM(false);
            setNtpDays('');

            history.goBack();
        } catch (error) {

            const errorMessage =
                error?.response?.data?.detail ||
                "Error while adding Report Team Member.";
            toast.error(errorMessage);


        }


    };


    return (
        <>
            <Container maxWidth="sm">
                <Grid
                    container
                    style={{ marginTop: 25 }}
                    direction="row"
                    justifyContent="space-around"
                    alignItems="center"
                    spacing={2}
                >
                    <Grid item xs={12}>
                        <TextField
                            id="reportType"
                            name="reportType"
                            label="Report Type"
                            value={repoertType}
                            fullWidth
                            margin="dense"
                            variant="standard"
                            InputProps={{
                                readOnly: true,
                            }}
                        />

                    </Grid>


                    <Grid item xs={12}>
                        {/* <TextField
                            id="reportReviewer"
                            name="reportReviewer"
                            label="Report Reviewer"
                            select
                            disabled={isReviewerPM}
                            value={repoertReviwer}
                            onChange={handleReportReviwer}
                            fullWidth
                            margin="dense"
                            data-testid="reportReviewer"
                            error={!!errors.repoertReviwer}
                            helperText={errors.repoertReviwer}
                        >
                            {ReportWriterData.map((item: any) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.username}
                                </MenuItem>
                            ))}
                        </TextField> */}
                        <Autocomplete
                            options={ReportWriterData || []}
                            disabled={isReviewerPM}
                            getOptionLabel={(option: any) => option.username || ""}
                            value={
                                ReportWriterData.find(
                                    (item: any) => item.id.toString() === repoertReviwer
                                ) || null
                            }
                            onChange={(e, newValue: any) => {
                                handleReportReviwer(newValue ? newValue.id.toString() : "");
                            }}
                            getOptionSelected={(option: any, value: any) => option.id === value.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Report Reviewer"
                                    margin="dense"
                                    fullWidth
                                    error={!!errors.repoertReviwer}
                                    helperText={errors.repoertReviwer}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isReviewerPM}
                                    onChange={handleReviewerPMChange}
                                    color="primary"
                                />
                            }
                            label="Is Reviewer is PM"
                        />

                    </Grid>

                    <Grid item xs={12}>
                        {/* <TextField
                            id="reportWriter"
                            name="reportWriter"
                            label="Report Writer"
                            select
                            value={repoertWritter}
                            onChange={handleReportWritter}
                            fullWidth
                            margin="dense"
                            data-testid="reportWriter"
                            error={!!errors.repoertWritter}
                            helperText={errors.repoertWritter}
                        >
                            {ReportWriterData.map((item: any) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.username}
                                </MenuItem>
                            ))}
                        </TextField> */}
                        <Autocomplete
                            options={ReportWriterData || []}
                            getOptionLabel={(option: any) => option.username || ""}
                            value={
                                ReportWriterData.find(
                                    (item: any) => item.id.toString() === repoertWritter
                                ) || null
                            }
                            onChange={(e, newValue: any) => {
                                handleReportWritter(newValue ? newValue.id.toString() : "");
                            }}
                            getOptionSelected={(option: any, value: any) => option.id === value.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Report Writer"
                                    margin="dense"
                                    fullWidth
                                    error={!!errors.repoertWritter}
                                    helperText={errors.repoertWritter}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        {/* <TextField
                            id="reportApprover"
                            name="reportApprover"
                            label="Report Approver"
                            select
                            disabled={showApprover}
                            value={repoertApprover}
                            onChange={handleReportApprover}
                            fullWidth
                            margin="dense"
                            data-testid="reportApprover"
                            error={!showApprover && !!errors.repoertApprover}
                            helperText={!showApprover ? errors.repoertApprover : ''}
                        >
                            {ReportApproverData.map((item: any) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.username}
                                </MenuItem>
                            ))}
                        </TextField> */}
                        <Autocomplete
                            options={ReportApproverData || []}
                            disabled={showApprover}
                            getOptionLabel={(option: any) => option.username || ""}
                            value={
                                ReportApproverData.find(
                                    (item: any) => item.id.toString() === repoertApprover
                                ) || null
                            }
                            onChange={(e, newValue: any) => {
                                handleReportApprover(newValue ? newValue.id.toString() : "");
                            }}
                            getOptionSelected={(option: any, value: any) => option.id === value.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Report Approver"
                                    margin="dense"
                                    fullWidth
                                    error={!showApprover && !!errors.repoertApprover}
                                    helperText={!showApprover ? errors.repoertApprover : ""}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showApprover}
                                    onChange={handleCheckboxChange}
                                    color="primary"
                                />
                            }
                            label="Is Project Manager"
                        />
                    </Grid>



                    <Grid item xs={12}>
                        <TextField
                            id="ntp"
                            size="small"
                            fullWidth
                            placeholder="Duration"
                            value={ntpDays}
                            onChange={(e) => setNtpDays(e.target.value)}
                            inputProps={{
                                maxLength: 3,
                                min: 0,
                                max: 999,
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                            }}
                            error={!!errors.ntpDays}
                            helperText={errors.ntpDays}
                            disabled
                        />
                    </Grid>





                    <Grid item xs={4} style={{ marginTop: 30 }}>
                        <Button
                            data-testid="submit"
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                        >
                            Update
                        </Button>
                    </Grid>
                </Grid>
            </Container>

        </>
    )
}


